






































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class IdrSheJiqi extends Vue {
  @Prop()
  private current: any;
  private cPart: any = "舌象信息输出";
  /**
   * @description 改变显示模块
   */
  private changePart(part) {
    this.cPart = part;
  }
}
